/*Implement target blank for Footer social links*/
document.addEventListener('click', function(event) {
    // Check if the clicked element (or its parent) matches your specific selector
    const link = event.target.closest('footer .social__item a');
    
    if (link && link.href) {
        // Stop the link from opening in the current window
        event.preventDefault(); 
        
        // Open the link in a new window or tab securely
        window.open(link.href, '_blank', 'noopener,noreferrer'); 
    }
});